module.exports = __webpack_public_path__ + "static/media/send.85b01c8e.svg";